import { PublicClientApplication, Configuration } from "@azure/msal-browser";

export const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const tenantId =  process.env.REACT_APP_AZURE_TENANT_ID;
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI;
const instance = process.env.REACT_APP_INSTANCE;
console.log(clientId, tenantId, redirectUri)

const msalConfig: Configuration = {
    auth: {
        clientId: `${clientId}`, 
        authority: `${instance}${tenantId}`,
        redirectUri: `${redirectUri}`,
        postLogoutRedirectUri: `${redirectUri}`,
    },
    cache: {
        cacheLocation: "localStorage", 
        storeAuthStateInCookie: false,
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const initializeMsalInstance = async () => {
    try {
        await msalInstance.initialize();
        console.log("MSAL instance initialized successfully");

    } catch (error) {
        console.error("Error initializing MSAL instance", error);
    }
};